<div class="pricing-package-page" testId="pricing-package-page">
  <div class="page-container" testId="pricing-package-container">
    <div class="page-shell">
      <section class="page-toolbar">
        <div class="page-heading">
          <div class="title-row">
            <div class="title-copy">
              <h1 class="page-title">{{ 'pricing.package.center.title' | i18n }}</h1>
              <p class="page-subtitle">{{ 'pricing.package.center.subtitle' | i18n }}</p>
              <div class="page-summary" *ngIf="!loading && !loadError">
                <span class="page-summary-count">{{ packages.length }}</span>
                <span>{{ (hasKeyword ? 'pricing.package.center.result.filtered' : 'pricing.package.center.result.all') | i18n }}</span>
                <span class="page-summary-keyword" *ngIf="hasKeyword">"{{ keyword.trim() }}"</span>
              </div>
            </div>
            <div class="toolbar-actions">
              <nz-input-group [nzSuffix]="searchIconTpl" class="page-search-group">
                <input
                  nz-input
                  class="page-search"
                  [(ngModel)]="keyword"
                  (ngModelChange)="onKeywordChange($event)"
                  [placeholder]="'pricing.package.center.search.placeholder' | i18n"
                  (keyup.enter)="search()"
                  testId="pricing-package-search-input"
                />
              </nz-input-group>
              <button
                nz-button
                type="button"
                class="action-btn secondary-btn"
                (click)="reset()"
                [disabled]="loading || !hasKeyword"
                testId="pricing-package-reset-button"
              >
                <i nz-icon nzType="reload"></i>
                {{ 'common.reset' | i18n }}
              </button>
              <button
                nz-button
                nzType="primary"
                type="button"
                class="action-btn primary-btn"
                (click)="openPackageModal()"
                [disabled]="loading"
                testId="pricing-package-create-button"
              >
                <i nz-icon nzType="plus"></i>
                {{ 'pricing.package.center.create' | i18n }}
              </button>
            </div>
          </div>
        </div>
      </section>

      <div class="form-container">
        <div class="pricing-package-content">
          <section class="content-section">
            <div class="loading-state" *ngIf="loading" testId="pricing-package-loading" aria-busy="true">
              <div class="loading-package-card" *ngFor="let _ of loadingPackagePlaceholders">
                <div class="loading-package-header">
                  <div class="loading-line loading-line-title"></div>
                  <div class="loading-chip"></div>
                </div>
                <div class="loading-package-meta">
                  <div class="loading-line loading-line-md" *ngFor="let __ of [0, 1, 2, 3]"></div>
                </div>
                <div class="loading-package-table">
                  <div class="loading-table-row" *ngFor="let __ of [0, 1, 2]">
                    <div class="loading-line loading-line-cell" *ngFor="let ___ of [0, 1, 2, 3, 4]"></div>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngIf="!loading">
              <ng-container *ngIf="!loadError; else loadErrorTpl">
                <ng-container *ngIf="packages.length; else emptyTpl">
                  <div class="package-list">
                    <nz-card
                      class="package-card"
                      *ngFor="let pkg of packages; let pi = index; trackBy: trackByPackage"
                      [testId]="'pricing-package-card-' + pi"
                    >
                      <div class="package-header">
                        <div class="package-title-block">
                          <div class="package-title-row">
                            <span class="package-kicker">
                              <i nz-icon nzType="appstore"></i>
                            </span>
                            <div class="package-title" nz-tooltip [nzTooltipTitle]="pkg.pricingName || pkg.pricingCode || '--'">
                              {{ pkg.pricingName || pkg.pricingCode || '--' }}
                            </div>
                            <nz-tag [class]="'status-tag ' + (pkg.deleted ? 'status-tag-danger' : 'status-tag-success')">
                              {{ pkg.deleted ? ('pricing.package.tag.disabled' | i18n) : ('pricing.package.tag.enabled' | i18n) }}
                            </nz-tag>
                            <span class="status-tag status-tag-info">
                              {{ getPricingTypeText(pkg.pricingType) }}
                            </span>
                            <span class="status-tag status-tag-info">
                              {{ getPackageItemCount(pkg) }} {{ 'pricing.package.items.title' | i18n }}
                            </span>
                          </div>
                          <div class="package-subtitle-row">
                            <div class="package-subtitle" nz-tooltip [nzTooltipTitle]="pkg.pricingCode || '--'">{{
                              pkg.pricingCode || '--'
                            }}</div>
                            <div class="package-inline-meta"
                              >{{ 'pricing.package.field.updated-at' | i18n }}: {{ formatDate(pkg.updateTime || pkg.createTime) }}</div
                            >
                          </div>
                        </div>
                        <div class="package-actions">
                          <button
                            nz-button
                            nzSize="small"
                            type="button"
                            class="list-action-btn"
                            (click)="openAuditDrawer(pkg)"
                            [testId]="'pricing-package-audit-button-' + pi"
                          >
                            <i nz-icon nzType="history"></i>
                            {{ 'pricing.package.action.audit' | i18n }}
                          </button>
                          <button
                            nz-button
                            nzSize="small"
                            type="button"
                            class="list-action-btn is-highlight"
                            (click)="openPackageModal(pkg)"
                            [testId]="'pricing-package-edit-button-' + pi"
                          >
                            <i nz-icon nzType="edit"></i>
                            {{ 'common.edit' | i18n }}
                          </button>
                          <button
                            nz-button
                            nzSize="small"
                            nzDanger
                            type="button"
                            class="list-action-btn"
                            (click)="confirmDeletePackage(pkg)"
                            [testId]="'pricing-package-delete-button-' + pi"
                          >
                            <i nz-icon nzType="delete"></i>
                            {{ 'common.delete' | i18n }}
                          </button>
                        </div>
                      </div>

                      <div class="package-items">
                        <div class="items-header">
                          <div class="items-title">
                            <span class="section-kicker">
                              <i nz-icon nzType="tags"></i>
                            </span>
                            {{ 'pricing.package.items.title' | i18n }}
                          </div>
                          <div class="items-actions">
                            <button
                              nz-button
                              nzSize="small"
                              type="button"
                              class="list-action-btn is-highlight"
                              (click)="openItemModal(pkg)"
                              [testId]="'pricing-package-item-create-button-' + pi"
                            >
                              <i nz-icon nzType="plus"></i>
                              {{ 'pricing.package.items.create' | i18n }}
                            </button>
                            <button
                              *ngIf="!isPointPackage(pkg) && !isAddonPackage(pkg)"
                              nz-button
                              nzSize="small"
                              type="button"
                              class="list-action-btn item-trial-action"
                              (click)="openTrialItemModal(pkg)"
                              [disabled]="hasTrialItem(pkg)"
                              [testId]="'pricing-package-trial-item-create-button-' + pi"
                            >
                              <i nz-icon nzType="gift"></i>
                              {{ 'pricing.package.items.create-trial' | i18n }}
                            </button>
                          </div>
                        </div>
                        <nz-table
                          [nzData]="pkg.items || []"
                          [nzFrontPagination]="false"
                          [nzShowPagination]="false"
                          [nzNoResult]="itemEmptyTpl"
                          nzSize="small"
                          class="items-table"
                          [testId]="'pricing-package-items-table-' + pi"
                        >
                          <thead>
                            <tr>
                              <th>{{ getItemPrimaryColumnLabel(pkg) }}</th>
                              <th>{{ getItemSecondaryColumnLabel(pkg) }}</th>
                              <th>
                                {{ getItemThirdColumnLabel(pkg) }}
                                <span class="th-unit" *ngIf="!isPointPackage(pkg)">
                                  / {{ isAddonPackage(pkg) ? ('pricing.package.item.field.addon-unit' | i18n) : '%' }}
                                </span>
                              </th>
                              <th>{{ 'pricing.package.item.field.description' | i18n }}</th>
                              <th>{{ 'pricing.package.item.field.status' | i18n }}</th>
                              <th class="op-col">{{ 'pricing.package.item.field.actions' | i18n }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let item of pkg.items || []; let ii = index; trackBy: trackByItem"
                              [testId]="'pricing-package-item-row-' + pi + '-' + ii"
                            >
                              <td>
                                <span class="item-duration-text">
                                  <strong>{{
                                    isPointPackage(pkg) || isAddonPackage(pkg) ? getItemNameText(item) : getItemDurationText(pkg, item)
                                  }}</strong>
                                  <nz-tag nzColor="gold" class="item-type-tag-trial" *ngIf="isPointPackage(pkg) && item.recommend">
                                    {{ 'pricing.package.tag.recommend' | i18n }}
                                  </nz-tag>
                                  <nz-tag nzColor="gold" class="item-type-tag-trial" *ngIf="isTrialItem(item)">
                                    {{ 'pricing.package.item.tag.trial' | i18n }}
                                  </nz-tag>
                                </span>
                              </td>
                              <td>
                                <ng-container *ngIf="isPointPackage(pkg); else addonOrStandardPriceCell">
                                  <span class="item-duration-text">
                                    <strong>{{ getItemDurationText(pkg, item) }}</strong>
                                  </span>
                                </ng-container>
                                <ng-template #addonOrStandardPriceCell>
                                  <ng-container *ngIf="isAddonPackage(pkg); else standardPriceCell">
                                    <span class="item-price-value">{{ getItemPriceText(item) }}</span>
                                  </ng-container>
                                </ng-template>
                                <ng-template #standardPriceCell>
                                  <div class="item-price-stack">
                                    <span class="item-price-value">{{ getItemPriceText(item) }}</span>
                                    <span class="item-price-original" *ngIf="shouldShowOriginalPrice(item)">{{
                                      getItemOriginalPriceText(item)
                                    }}</span>
                                    <span class="item-price-meta" *ngIf="!isTrialItem(item)">{{ getItemMonthlyAverageLabel(item) }}</span>
                                  </div>
                                </ng-template>
                              </td>
                              <td>
                                <ng-container *ngIf="isPointPackage(pkg); else addonOrStandardDiscountCell">
                                  <span class="item-price-value">{{ getItemPriceText(item) }}</span>
                                </ng-container>
                                <ng-template #addonOrStandardDiscountCell>
                                  <ng-container *ngIf="isAddonPackage(pkg); else standardDiscountCell">
                                    <span class="item-duration-text"
                                      ><strong>{{ getItemDurationText(pkg, item) }}</strong></span
                                    >
                                  </ng-container>
                                </ng-template>
                                <ng-template #standardDiscountCell>
                                  <span class="item-discount-badge" [class.is-empty]="formatDiscountRate(item.discountRate) === '--'">
                                    {{ formatDiscountRate(item.discountRate) }}
                                  </span>
                                </ng-template>
                              </td>
                              <td>
                                <span class="item-cell item-description" nz-tooltip [nzTooltipTitle]="item.description || '--'">
                                  {{ item.description || '--' }}
                                </span>
                              </td>
                              <td>
                                <nz-tag [class]="'status-tag ' + (item.deleted ? 'status-tag-danger' : 'status-tag-success')">
                                  {{
                                    item.deleted
                                      ? ('pricing.package.item.status.disabled' | i18n)
                                      : ('pricing.package.item.status.enabled' | i18n)
                                  }}
                                </nz-tag>
                              </td>
                              <td class="op-col">
                                <div class="item-row-actions">
                                  <button
                                    nz-button
                                    nzSize="small"
                                    type="button"
                                    class="list-action-btn item-audit-action"
                                    (click)="openAuditDrawer(pkg, item)"
                                    [testId]="'pricing-package-item-audit-button-' + pi + '-' + ii"
                                  >
                                    <i nz-icon nzType="history"></i>
                                    {{ 'pricing.package.action.audit' | i18n }}
                                  </button>
                                  <button
                                    nz-button
                                    nzSize="small"
                                    type="button"
                                    class="list-action-btn is-highlight"
                                    (click)="openItemModal(pkg, item)"
                                    [testId]="'pricing-package-item-edit-button-' + pi + '-' + ii"
                                  >
                                    <i nz-icon nzType="edit"></i>
                                    {{ 'common.edit' | i18n }}
                                  </button>
                                  <button
                                    nz-button
                                    nzSize="small"
                                    nzDanger
                                    type="button"
                                    class="list-action-btn"
                                    (click)="confirmDeleteItem(pkg, item)"
                                    [testId]="'pricing-package-item-delete-button-' + pi + '-' + ii"
                                  >
                                    <i nz-icon nzType="delete"></i>
                                    {{ 'common.delete' | i18n }}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </nz-table>
                      </div>
                    </nz-card>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyTpl>
  <div class="empty-state">
    <div class="empty-state-visual" [class.is-filtered]="isFilteredEmpty">
      <div class="empty-state-orb"></div>
      <nz-empty [nzNotFoundContent]="emptyDescriptionTpl" />
    </div>
  </div>
</ng-template>

<ng-template #emptyDescriptionTpl>
  <div class="empty-state-copy">
    <div class="empty-state-title">
      {{ (isFilteredEmpty ? 'pricing.package.center.empty.search' : 'pricing.package.center.empty') | i18n }}
    </div>
    <div class="empty-state-subtitle">
      {{ (isFilteredEmpty ? 'pricing.package.center.empty.search.subtitle' : 'pricing.package.center.empty.default.subtitle') | i18n }}
    </div>
    <div class="empty-state-actions">
      <button
        nz-button
        type="button"
        class="action-btn secondary-btn"
        *ngIf="isFilteredEmpty"
        (click)="reset()"
        testId="pricing-package-empty-clear-search-button"
      >
        <i nz-icon nzType="undo"></i>
        {{ 'pricing.package.center.action.clear-search' | i18n }}
      </button>
      <button
        nz-button
        nzType="primary"
        type="button"
        class="action-btn primary-btn"
        *ngIf="!isFilteredEmpty"
        (click)="openPackageModal()"
        testId="pricing-package-empty-create-button"
      >
        <i nz-icon nzType="plus"></i>
        {{ 'pricing.package.center.create' | i18n }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #loadErrorTpl>
  <div class="empty-state">
    <div class="empty-state-visual is-error">
      <div class="empty-state-copy">
        <div class="empty-state-title">{{ 'pricing.package.center.error.title' | i18n }}</div>
        <div class="empty-state-subtitle">{{ 'pricing.package.center.error.subtitle' | i18n }}</div>
        <div class="empty-state-actions">
          <button
            nz-button
            type="button"
            class="action-btn secondary-btn"
            (click)="retryLoad()"
            testId="pricing-package-error-retry-button"
          >
            <i nz-icon nzType="reload"></i>
            {{ 'common.refresh' | i18n }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #searchIconTpl>
  <i nz-icon nzType="search" class="page-search-icon" (click)="search()"></i>
</ng-template>

<ng-template #itemEmptyTpl>
  <nz-empty [nzNotFoundContent]="'pricing.package.items.empty' | i18n" />
</ng-template>

<nz-modal
  [(nzVisible)]="packageModalVisible"
  [nzTitle]="editingPackage ? ('pricing.package.modal.edit' | i18n) : ('pricing.package.modal.create' | i18n)"
  [nzOkLoading]="packageModalLoading"
  [nzWidth]="560"
  [nzOkText]="'common.save' | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  (nzOnCancel)="closePackageModal()"
  (nzOnOk)="savePackage()"
  testId="pricing-package-modal"
>
  <ng-container *nzModalContent>
    <div class="pricing-package-modal-form pricing-package-modal-form-package">
      <div class="pricing-package-modal-intro">
        <div class="pricing-package-modal-kicker">{{ 'pricing.package.field.pricing-type' | i18n }}</div>
        <div class="pricing-package-modal-intro-main">
          <div>
            <div class="pricing-package-modal-intro-title">{{ getPricingTypeText(packageDraft.pricingType) }}</div>
            <div class="pricing-package-modal-intro-text">{{ 'pricing.package.modal.tip' | i18n }}</div>
          </div>
          <div class="pricing-package-required-badge">{{ 'pricing.package.required-badge' | i18n }}</div>
        </div>
      </div>

      <div class="pricing-package-form-section">
        <div class="pricing-package-form-section-title">{{ 'pricing.package.field.pricing-type' | i18n }}</div>
        <div class="pricing-package-type-segment pricing-package-type-segment-three" testId="pricing-package-type-select">
          <button
            nz-button
            type="button"
            class="pricing-package-type-option"
            [class.is-active]="packageDraft.pricingType === 'DurationPackage'"
            [disabled]="packageModalLoading"
            (click)="packageDraft.pricingType = 'DurationPackage'"
            testId="pricing-package-type-duration-btn"
          >
            <span class="pricing-package-type-option-title">{{ 'pricing.package.pricing-type.duration' | i18n }}</span>
            <span class="pricing-package-type-option-desc">{{ 'pricing.package.item.field.duration-months' | i18n }}</span>
          </button>
          <button
            nz-button
            type="button"
            class="pricing-package-type-option"
            [class.is-active]="packageDraft.pricingType === 'PointPackage'"
            [disabled]="packageModalLoading"
            (click)="packageDraft.pricingType = 'PointPackage'"
            testId="pricing-package-type-point-btn"
          >
            <span class="pricing-package-type-option-title">{{ 'pricing.package.pricing-type.point' | i18n }}</span>
            <span class="pricing-package-type-option-desc">{{ 'pricing.package.item.field.total-points' | i18n }}</span>
          </button>
          <button
            nz-button
            type="button"
            class="pricing-package-type-option"
            [class.is-active]="packageDraft.pricingType === 'AddonPackage'"
            [disabled]="packageModalLoading"
            (click)="packageDraft.pricingType = 'AddonPackage'"
            testId="pricing-package-type-addon-btn"
          >
            <span class="pricing-package-type-option-title">{{ 'pricing.package.pricing-type.addon' | i18n }}</span>
            <span class="pricing-package-type-option-desc">{{ 'pricing.package.item.field.addon-value' | i18n }}</span>
          </button>
        </div>
      </div>

      <div class="pricing-package-form-grid pricing-package-form-grid-two-column">
        <label class="pricing-package-form-row">
          <span class="pricing-package-form-label">
            {{ 'pricing.package.field.code' | i18n }}
            <span class="pricing-package-required-mark">*</span>
          </span>
          <div class="pricing-package-input-shell">
            <input
              nz-input
              [(ngModel)]="packageDraft.pricingCode"
              [disabled]="packageModalLoading"
              required
              testId="pricing-package-code-input"
            />
          </div>
        </label>
        <label class="pricing-package-form-row">
          <span class="pricing-package-form-label">
            {{ 'pricing.package.field.name' | i18n }}
            <span class="pricing-package-required-mark">*</span>
          </span>
          <div class="pricing-package-input-shell">
            <input
              nz-input
              [(ngModel)]="packageDraft.pricingName"
              [disabled]="packageModalLoading"
              required
              testId="pricing-package-name-input"
            />
          </div>
        </label>
      </div>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="itemModalVisible"
  [nzTitle]="editingItem ? ('pricing.package.item.modal.edit' | i18n) : ('pricing.package.item.modal.create' | i18n)"
  [nzOkLoading]="itemModalLoading"
  [nzWidth]="560"
  [nzOkText]="'common.save' | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  (nzOnCancel)="closeItemModal()"
  (nzOnOk)="saveItem()"
  testId="pricing-package-item-modal"
>
  <ng-container *nzModalContent>
    <div class="pricing-package-modal-form">
      <div class="pricing-package-modal-intro">
        <div class="pricing-package-modal-kicker">{{ itemPackage?.pricingName || itemPackage?.pricingCode || '--' }}</div>
        <div class="pricing-package-modal-intro-main">
          <div>
            <div class="pricing-package-modal-intro-title">{{ getPricingTypeText(itemPackage?.pricingType) }}</div>
            <div class="pricing-package-modal-intro-text">
              {{
                isPointPackage(itemPackage)
                  ? ('pricing.package.item.modal.tip.point' | i18n)
                  : isAddonPackage(itemPackage)
                    ? ('pricing.package.item.modal.tip.addon' | i18n)
                    : ('pricing.package.item.modal.tip' | i18n)
              }}
            </div>
          </div>
          <span class="pricing-package-modal-chip" *ngIf="isTrialItem(itemDraft)">{{ 'pricing.package.item.tag.trial' | i18n }}</span>
        </div>
      </div>
      <div class="pricing-package-form-grid">
        <label class="pricing-package-form-row" *ngIf="isPointPackage(itemPackage) || isAddonPackage(itemPackage)">
          <span class="pricing-package-form-label">
            {{ 'pricing.package.field.name' | i18n }}
            <span class="pricing-package-required-mark">*</span>
          </span>
          <div class="pricing-package-input-shell">
            <input nz-input [(ngModel)]="itemDraft.name" [disabled]="itemModalLoading" required testId="pricing-package-item-name-input" />
          </div>
        </label>
        <label
          class="pricing-package-form-row"
          *ngIf="!isTrialItem(itemDraft) && !isPointPackage(itemPackage) && !isAddonPackage(itemPackage); else specialMetricField"
        >
          <span class="pricing-package-form-label">
            {{ 'pricing.package.item.field.duration-months' | i18n }}
            <span class="pricing-package-required-mark">*</span>
          </span>
          <div class="pricing-package-input-shell has-unit">
            <nz-input-number
              [(ngModel)]="itemDraft.durationMonths"
              [nzMin]="1"
              [nzDisabled]="itemModalLoading"
              class="pricing-package-form-number"
              testId="pricing-package-item-duration-months-input"
              required
            />
            <span class="pricing-package-input-unit pricing-package-input-unit-inline">{{
              'pricing.package.item.duration.months' | i18n
            }}</span>
          </div>
        </label>
        <ng-template #specialMetricField>
          <ng-container *ngIf="isPointPackage(itemPackage); else addonOrTrialDaysField">
            <label class="pricing-package-form-row">
              <span class="pricing-package-form-label">
                {{ 'pricing.package.item.field.base-points' | i18n }}
                <span class="pricing-package-required-mark">*</span>
              </span>
              <div class="pricing-package-input-shell">
                <nz-input-number
                  [(ngModel)]="itemDraft.basePoints"
                  [nzMin]="1"
                  [nzDisabled]="itemModalLoading"
                  class="pricing-package-form-number"
                  testId="pricing-package-item-base-points-input"
                  required
                />
              </div>
            </label>
            <label class="pricing-package-form-row">
              <span class="pricing-package-form-label">
                {{ 'pricing.package.item.field.bonus-points' | i18n }}
                <span class="pricing-package-required-mark">*</span>
              </span>
              <div class="pricing-package-input-shell">
                <nz-input-number
                  [(ngModel)]="itemDraft.bonusPoints"
                  [nzMin]="0"
                  [nzDisabled]="itemModalLoading"
                  class="pricing-package-form-number"
                  testId="pricing-package-item-bonus-points-input"
                  required
                />
              </div>
            </label>
          </ng-container>
        </ng-template>
        <ng-template #addonOrTrialDaysField>
          <ng-container *ngIf="isAddonPackage(itemPackage); else trialDaysField">
            <label class="pricing-package-form-row">
              <span class="pricing-package-form-label">
                {{ 'pricing.package.item.field.addon-value' | i18n }}
                <span class="pricing-package-required-mark">*</span>
              </span>
              <div class="pricing-package-input-shell has-unit">
                <nz-input-number
                  [(ngModel)]="itemDraft.addonValue"
                  [nzMin]="1"
                  [nzDisabled]="itemModalLoading"
                  class="pricing-package-form-number"
                  testId="pricing-package-item-addon-value-input"
                  required
                />
                <span class="pricing-package-input-unit pricing-package-input-unit-inline">{{
                  'pricing.package.item.field.addon-unit' | i18n
                }}</span>
              </div>
            </label>
          </ng-container>
        </ng-template>
        <ng-template #trialDaysField>
          <label class="pricing-package-form-row">
            <span class="pricing-package-form-label">
              {{ 'pricing.package.item.field.trial-days' | i18n }}
              <span class="pricing-package-required-mark">*</span>
            </span>
            <div class="pricing-package-input-shell has-unit">
              <nz-input-number
                [(ngModel)]="itemDraft.trialDays"
                [nzMin]="1"
                [nzDisabled]="itemModalLoading"
                class="pricing-package-form-number"
                testId="pricing-package-item-trial-days-input"
                required
              />
              <span class="pricing-package-input-unit pricing-package-input-unit-inline">{{
                'pricing.package.item.duration.days' | i18n
              }}</span>
            </div>
          </label>
        </ng-template>
        <label class="pricing-package-form-row" *ngIf="!isTrialItem(itemDraft)">
          <span class="pricing-package-form-label">
            {{ 'pricing.package.item.field.price' | i18n }}
            <span class="pricing-package-required-mark">*</span>
          </span>
          <div class="pricing-package-input-shell has-unit">
            <nz-input-number
              [(ngModel)]="itemDraft.priceCny"
              [nzMin]="0"
              [nzDisabled]="itemModalLoading"
              class="pricing-package-form-number"
              testId="pricing-package-item-price-cny-input"
              required
            />
            <span class="pricing-package-input-unit pricing-package-input-unit-inline">{{ 'pricing.package.currency.twd' | i18n }}</span>
          </div>
        </label>
        <label
          class="pricing-package-form-row"
          *ngIf="!isTrialItem(itemDraft) && !isPointPackage(itemPackage) && !isAddonPackage(itemPackage)"
        >
          <span>{{ 'pricing.package.item.field.discount' | i18n }}</span>
          <div class="pricing-package-input-shell has-unit">
            <nz-input-number
              [(ngModel)]="itemDraft.discountRate"
              [nzMin]="0"
              [nzStep]="0.01"
              [nzDisabled]="itemModalLoading"
              class="pricing-package-form-number"
              testId="pricing-package-item-discount-rate-input"
            />
            <span class="pricing-package-input-unit pricing-package-input-unit-inline">%</span>
          </div>
        </label>
        <label
          class="pricing-package-form-row"
          *ngIf="!isTrialItem(itemDraft) && !isPointPackage(itemPackage) && !isAddonPackage(itemPackage)"
        >
          <span>{{ 'pricing.package.item.field.discount-price' | i18n }}</span>
          <div class="pricing-package-input-shell has-unit is-readonly">
            <input
              nz-input
              [ngModel]="getDraftDiscountPriceText()"
              readonly
              [disabled]="itemModalLoading"
              testId="pricing-package-item-discount-price-input"
            />
            <span class="pricing-package-input-unit pricing-package-input-unit-inline">{{ 'pricing.package.currency.twd' | i18n }}</span>
          </div>
          <small class="pricing-package-form-hint">{{ 'pricing.package.item.field.discount-price-hint' | i18n }}</small>
        </label>
      </div>
      <label class="pricing-package-form-row is-full">
        <span class="pricing-package-form-label">
          {{ 'pricing.package.item.field.description' | i18n }}
          <span class="pricing-package-required-mark">*</span>
        </span>
        <div class="pricing-package-input-shell">
          <textarea
            nz-input
            [(ngModel)]="itemDraft.description"
            [disabled]="itemModalLoading"
            required
            rows="3"
            testId="pricing-package-item-description-input"
          ></textarea>
        </div>
      </label>
    </div>
  </ng-container>
</nz-modal>

<nz-drawer
  [nzVisible]="auditDrawerVisible"
  [nzTitle]="'pricing.package.audit.title' | i18n"
  [nzWidth]="560"
  (nzOnClose)="closeAuditDrawer()"
  testId="pricing-package-audit-drawer"
>
  <ng-container *nzDrawerContent>
    <nz-spin [nzSpinning]="auditDrawerLoading">
      <div class="pricing-package-audit-header">
        <div class="pricing-package-audit-title">{{
          auditContext?.package?.pricingName || auditContext?.package?.pricingCode || '--'
        }}</div>
        <div class="pricing-package-audit-subtitle" *ngIf="auditContext?.item">
          {{ auditContext?.item?.pricingCode || auditContext?.item?.id || '--' }}
        </div>
      </div>
      <div class="pricing-package-audit-list" *ngIf="auditLogs.length; else auditEmptyTpl">
        <div class="pricing-package-audit-card" *ngFor="let log of auditLogs; trackBy: trackByAuditLog">
          <div class="pricing-package-audit-card-head">
            <div>
              <div class="pricing-package-audit-card-kicker">{{ getAuditActionText(log.action) }}</div>
              <div class="pricing-package-audit-card-title">{{ getAuditSummary(log) }}</div>
            </div>
            <div class="pricing-package-audit-card-time">{{ formatDate(log.createTime) }}</div>
          </div>
          <div class="pricing-package-audit-card-meta">
            <span>{{ 'pricing.package.audit.operator' | i18n }}{{ log.operatorName || log.operatorId || '--' }}</span>
            <span>{{ 'pricing.package.audit.code' | i18n }}{{ log.pricingCode || '--' }}</span>
          </div>
          <div class="pricing-package-audit-change-table" *ngIf="getAuditChangeRows(log) as rows">
            <div class="pricing-package-audit-change-head" *ngIf="rows.length">
              <span>{{ 'pricing.package.audit.field' | i18n }}</span>
              <span>{{ 'pricing.package.audit.old-value' | i18n }}</span>
              <span>{{ 'pricing.package.audit.new-value' | i18n }}</span>
            </div>
            <div
              class="pricing-package-audit-change-row"
              *ngFor="let row of rows; trackBy: trackByAuditChange"
              [class.is-changed]="row.changed"
            >
              <div class="pricing-package-audit-change-field">{{ row.label }}</div>
              <div class="pricing-package-audit-change-value">{{ row.before }}</div>
              <div class="pricing-package-audit-change-value is-new">{{ row.after }}</div>
            </div>
            <div class="pricing-package-audit-change-empty" *ngIf="!rows.length">
              {{ 'pricing.package.audit.no-readable-change' | i18n }}
            </div>
          </div>
          <div class="pricing-package-audit-raw">
            <button
              nz-button
              nzType="text"
              type="button"
              class="pricing-package-audit-raw-toggle"
              (click)="toggleAuditRawData(log)"
              testId="pricing-package-audit-raw-toggle-button"
            >
              <span nz-icon [nzType]="isAuditRawOpen(log) ? 'up' : 'down'"></span>
              {{ 'pricing.package.audit.raw-toggle' | i18n }}
            </button>
            <div class="pricing-package-audit-raw-panel" *ngIf="isAuditRawOpen(log)">
              <div class="pricing-package-audit-raw-block">
                <div class="pricing-package-audit-raw-label">{{ 'pricing.package.audit.old-value' | i18n }}</div>
                <pre>{{ getAuditRawText(log, 'before') }}</pre>
              </div>
              <div class="pricing-package-audit-raw-block">
                <div class="pricing-package-audit-raw-label">{{ 'pricing.package.audit.new-value' | i18n }}</div>
                <pre>{{ getAuditRawText(log, 'after') }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #auditEmptyTpl>
        <nz-empty [nzNotFoundContent]="'pricing.package.audit.empty' | i18n" />
      </ng-template>
      <div class="pricing-package-audit-pagination" *ngIf="auditTotalCount > 0">
        <nz-pagination
          [nzTotal]="auditTotalCount"
          [nzPageIndex]="auditPageIndex + 1"
          [nzPageSize]="auditPageSize"
          [nzShowSizeChanger]="true"
          [nzPageSizeOptions]="[10, 20, 50]"
          (nzPageIndexChange)="onAuditPageIndexChange($event)"
          (nzPageSizeChange)="onAuditPageSizeChange($event)"
          testId="pricing-package-audit-pagination"
        />
      </div>
    </nz-spin>
  </ng-container>
</nz-drawer>
